<script setup lang="ts">
import type { Props } from '@/presentation/components/templates/DefaultTemplateProps.ts'
import CLateralBar from '@/presentation/components/navigation/lateralBar/CLateralBar.vue'

const localProps = defineProps<Props>()
</script>

<template>
  <div class="flex h-full max-h-full">
    <div v-if="localProps.withSidebar">
      <c-lateral-bar />
    </div>

    <div class="flex-1 overflow-hidden">
      <div class="bg-surface-50 flex h-full flex-col overflow-hidden">
        <slot />
      </div>
    </div>
  </div>
</template>
